import styled from 'styled-components';

export const TopBannersLayoutStyled = styled.div`
  min-width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;
